import { objectType } from "_src/constants";
import AbstractManipulator from "_src/client/manipulators/abstract_manipulator";

import windowManager from "_src/client/window_manager";
import renderGraph from "_src/render_graph/render_graph";
import workspace from "_src/workspace";
import {BufferReaderType} from "_src/client/buffer_reader";
import {CAD_HIGHLIGHT} from "_src/render_graph/passes/highlight_pass";

export default class CadPicker extends AbstractManipulator {
  constructor(camera) {

    super(camera);
    this._highlightedObject = null;
  }

  async _mouseMoveHandler({screenX, screenY}) {
    const graph = windowManager.getWindow(windowManager.MAIN).renderGraph;
    const outlinePass = graph.getPass(renderGraph.OUTLINE);

    const cadToHighlight = await getCadToHighlight(screenX, screenY);
    if (cadToHighlight !== this._highlightedObject) {
      if (this._highlightedObject) this._highlightedObject.setSelected(false, outlinePass);
      if (cadToHighlight) cadToHighlight.setSelected(true, outlinePass);

      this._highlightedObject = cadToHighlight;
      windowManager.getWindow(windowManager.MAIN).renderGraph.requestFrame();
    }
    if (cadToHighlight) {
      cadToHighlight.pickPoint(screenX, screenY);
      windowManager.getWindow(windowManager.MAIN).renderGraph.requestFrame();
      workspace.activateObjectOutline(this, outlinePass, CAD_HIGHLIGHT);
    }
  }

  _resizeHandler() {
    this._updateScales();
  }

  _cameraMoveHandler(camera) {
    if (camera !== this._camera) {
      return;
    }

    this._updateScales();
  }

  _showCadElements() {
    const mainWindow = windowManager.getWindow(windowManager.MAIN);
    const mainRenderGraph = mainWindow.renderGraph;
    const measureLinesPass = mainRenderGraph.getPass(renderGraph.MEASURE_LINES);
    for (const object of workspace.getObjects().filter(object => object.type === objectType.CAD && object.isPrimitive())) {
      object.setScenes(measureLinesPass.getMainScene(), measureLinesPass.getSecondScene());
      object.addSpecialModelsToScenes(mainRenderGraph.getPostBlendingScene(), mainRenderGraph.getCadsAdditionalScene());
    }
    mainWindow.updateObjectsScene();
  }

  _hideCadElements() {
    const mainRenderGraph = windowManager.getWindow(windowManager.MAIN).renderGraph;
    for (const object of workspace.getObjects().filter(object => object.type === objectType.CAD && object.isPrimitive())) {
      object.removeSpecialModelsFromScenes(null, mainRenderGraph.getCadsAdditionalScene());
      object.setScenes(null, null);
    }

    this._highlightedObject = null;
  }

  async _onStart() {
    this._showCadElements();
  }

  _onStop() {
    this._hideCadElements();
  }

  _updateScales() {
    for (const cadObject of workspace.getObjects().filter(object => object.type === objectType.CAD && object.isPrimitive() && object.getVisibility())) {
      cadObject.updateScreenAppearance();
    }
  }
}

async function getCadToHighlight(screenX, screenY) {
  const mainWindow = windowManager.getWindow(windowManager.MAIN);
  const textureX = mainWindow.toViewportX(screenX);
  const textureY = mainWindow.toViewportY(screenY);
  if (!mainWindow.isInViewport(screenX, screenY)) {
    return null;
  }

  const pickID = await mainWindow.bufferReader.readPixelCache(textureX, textureY, BufferReaderType.OBJECT_ID);
  const object = workspace.getObjectByID(pickID);
  if (!(object && object.type === objectType.CAD && object.isPrimitive())) {
    return null;
  }

  return object;
}

//reimplement axis widget logic
/*
  if (selected) {
    workspace.activateObjectOutline(this, outlinePass, CAD_HIGHLIGHT);
  } else {
  workspace.deactivateObjectOutline(this);
}

if (this._axisWidget) this._axisWidget.setSelected(selected);
 */
